import { ReactNode } from "react";
import { Control, FieldValues, Path, useController } from "react-hook-form";
import { TextField } from "theme";

import { TextFieldProps } from "../../theme/components/TextField/TextField.tsx";

interface ControlledTextFiledProps<TFieldValues extends FieldValues> extends TextFieldProps {
  control: Control<TFieldValues>;
  name: Path<TFieldValues>;
  loading?: boolean;
  link?: ReactNode;
  maxLength?: number;
}

const ControlledTextField = <TFieldValues extends FieldValues>({
  control,
  name,
  loading,
  placeholder,
  label,
  required,
  type,
  multiline,
  ...rest
}: ControlledTextFiledProps<TFieldValues>) => {
  const {
    field: { ref, ...fields },
    fieldState: { error },
  } = useController({ name, control });

  return (
    <TextField
      inputRef={ref}
      type={type}
      error={Boolean(error)}
      placeholder={placeholder}
      label={label}
      required={required}
      InputProps={{
        ...rest.InputProps,
        readOnly: loading,
      }}
      multiline={multiline}
      {...fields}
      {...rest}
    />
  );
};

export default ControlledTextField;
